import { validDADate } from './daTimeline';

export function formatLotPlan(lot, plan) {
  const lotText = String(lot || '').trim().replace(/^(?:lot\s+)+/i, '');
  return [lotText ? `Lot ${lotText}` : '', String(plan || '').trim()].filter(Boolean).join(' / ') || null;
}

function singlePlan(value) {
  const matches = [...String(value || '').matchAll(/\b(DP|SP)\s*[-:]?\s*(\d+)\b/gi)];
  const plans = [...new Set(matches.map(([, kind, number]) => `${kind.toUpperCase()}${number.replace(/^0+(?=\d)/, '')}`))];
  return plans.length === 1 ? plans[0] : null;
}

// Display-only cleanup: retain raw evidence in storage for review.
export function cleanReferralAgencies(values) {
  const seen = new Set();
  return (Array.isArray(values) ? values : []).filter(value => {
    if (typeof value !== 'string' || !value.trim()) return false;
    if (/\b(?:excluded|not an agency|not applicable|no referral|not referred)\b/i.test(value)) return false;
    const key = value.trim().toLowerCase().replace(/\s*\(rfs\)\s*$/i, '').replace(/\s+/g, ' ');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).map(value => value.trim());
}

export function getProRecordConflicts(record, data) {
  if (!record || !data) return [];
  const conflicts = [];
  const recordPlan = singlePlan(record.lot_id_string);
  const proPlan = singlePlan(data.dp_number);
  if (recordPlan && proPlan && recordPlan !== proPlan) {
    conflicts.push(`The record lists ${recordPlan}, but the Pro planning details list ${proPlan}. The property identifiers conflict; check the council source before relying on the planning details.`);
  }
  if (record.application_type && data.application_type && record.application_type.toLowerCase() !== data.application_type.toLowerCase()) {
    conflicts.push('The record type and Pro source type differ. Pro details may describe a related application; confirm which record applies before relying on them.');
  }
  const lodged = validDADate(record.lodged_date);
  if (lodged && (Array.isArray(data.tracking_milestones) ? data.tracking_milestones : []).some(m => {
    const label = m?.description || m?.event || m?.milestone || m?.name || '';
    const date = m?.completed || m?.commenced || m?.date || m?.event_date || m?.created_at;
    return /lodg/i.test(label) && validDADate(date) && String(date).slice(0, 10) !== record.lodged_date.slice(0, 10);
  })) conflicts.push('The lodged dates in the record and Pro timeline differ. Both are retained for checking; neither has been confirmed as the correct date.');
  return conflicts;
}
